import { Injectable } from '@angular/core';
import { Country, Market, SearcherStation, Station } from '@vueling-ng/vy-cdk-searcher';

@Injectable({
  providedIn: 'root'
})
export class ConverterSearcherStationsService {
  public mapOrigins(stations: Station[], countries: Country[]): SearcherStation[] {
    return stations.map((station) => {
      return {
        name: station.shortName,
        code: station.stationCode,
        countryCode: station.locationDetails.countryCode,
        connection: '',
        countryName: countries.find((country) => country.countryCode === station.locationDetails.countryCode)!.name,
        isMac: station.stationCode === 'BCN',
        enabled: station.allowed
      } as SearcherStation;
    });
  }
  public mapDestinations(origins: SearcherStation[], markets: Market[]): SearcherStation[] {
    return origins.map((station) => {
      const market = markets.find((market) => station.code === market.toCode);
      return {
        name: station.name,
        code: station.code,
        countryCode: station.countryCode,
        connection: market!.connection,
        countryName: station.countryName,
        marketProperty: market!.marketProperty,
        enabled: station.enabled
      } as SearcherStation;
    });
  }
}
